import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";

import Navbar from "./components/common/Navbar";
import LandingPage from "./components/pages/LandingPage";
import Careers from "./components/pages/Careers";

// import Services from "./components/pages/Services";

import ScrollToTop from "./components/common/ScrollToTop";

/* Product Pages */
// import Agriculture from "./components/pages/products/Agriculture";
// import ElectricMobility from "./components/pages/products/ElectricMobility";
// import RenewableEnergy from "./components/pages/products/RenewableEnergy";
// import HomeAutomation from "./components/pages/products/HomeAutomation";

function App() {
  return (
    <BrowserRouter>

      <ScrollToTop />

      <Navbar />

      <Routes>

        <Route path="/" element={<LandingPage />} />

        {/* SECTION NAVIGATION */}
        <Route path="/products" element={<LandingPage />} />
        <Route path="/services" element={<LandingPage />} />

        <Route path="/careers" element={<Careers />} />

        {/* PRODUCT ROUTES (FOR FUTURE) */}
        {/*
        <Route path="/products/agriculture" element={<Agriculture />} />
        <Route path="/products/electric-mobility" element={<ElectricMobility />} />
        <Route path="/products/renewable-energy" element={<RenewableEnergy />} />
        <Route path="/products/home-automation" element={<HomeAutomation />} />
        */}

      </Routes>

    </BrowserRouter>
  );
}

export default App;